import styled from "styled-components";
import { Theme } from "../../themes/theme";

const Wrapper = styled.h2`
  text-transform: uppercase;
  margin: 0;
  color: ${Theme.color.text.heading};
  font-size: ${Theme.font.fontSize.xxxl};
  font-weight: ${Theme.font.fontWeight.bold};
  line-height: ${Theme.font.lineHeight.tight};
  font-family: ${Theme.font.fontFamily.heading};
  letter-spacing: ${Theme.font.letterSpacing.normal};

  span {
    color: ${Theme.color.text.primary};
  }
`;

function H2({ children }) {
  return <Wrapper>{children}</Wrapper>;
}

export default H2;
